import { CaptionsPlacement } from '@goldcast/player-config/src/types/asset-types';
import { CAPTIONS_PLACEMENT_OPTIONS } from './CaptionsMenu/constants';

export function getNextCaptionsPlacement(current: CaptionsPlacement | undefined): CaptionsPlacement {
  const currentPlacement = CAPTIONS_PLACEMENT_OPTIONS.find(o => o.value === current);
  return currentPlacement?.next || CaptionsPlacement.Top;
}

export function getCaptionsPlacementMargin(
  playerHeight: number,
  captionsHeight: number,
  placement?: CaptionsPlacement
): number {
  switch (placement) {
    case CaptionsPlacement.Top:
      return playerHeight - captionsHeight;
    case CaptionsPlacement.Middle:
      return (playerHeight - captionsHeight) / 2;
    default:
      return 0;
  }
}

export function getCaptionsLineHeight(captionsFontSize: number): number {
  return (5 * captionsFontSize) / 2.8;
}
